import React from "react";

import "../PublicHouse.css";

export const PublicInz = ({ formDataPublic, onDataChange }) => {

  //Считывание данных
  const handleInputChange = (e) => {
    const { id, value } = e.target;
    onDataChange({ ...formDataPublic, [id]: value });
  };

  return (
    <div className="Public_Inz_Main">
      <div className="Public_Inz_Inputs">
        <div className="Public_Inz_Input_Field_Group">
          <input
            className="Public_Inz_Input_Field"
            type="number"
            id="hot_water_system"
            placeholder="Система горячего водоснабжения, всего, м"
            required
            value={formDataPublic.hot_water_system || ''}
            onChange={handleInputChange}
          />
          <input
            className="Public_Inz_Input_Field"
            type="number"
            id="central_heating_system"
            placeholder="Система центрального отопления, всего, м"
            required
            value={formDataPublic.central_heating_system || ''}
            onChange={handleInputChange}
          />
          <input
            className="Public_Inz_Input_Field"
            type="number"
            id="cold_water_system"
            placeholder="Система холодного водоснабжения, всего, м"
            required
            value={formDataPublic.cold_water_system || ''}
            onChange={handleInputChange}
          />
          <input
            className="Public_Inz_Input_Field"
            type="number"
            id="sewage_system"
            placeholder="Система канализации, всего, м"
            required
            value={formDataPublic.sewage_system || ''}
            onChange={handleInputChange}
          />
          <input
            className="Public_Inz_Input_Field"
            type="number"
            id="electrical_system"
            placeholder="Система электрооборудования, всего, м"
            required
            value={formDataPublic.electrical_system || ''}
            onChange={handleInputChange}
          />
          <input
            className="Public_Inz_Input_Field"
            type="number"
            id="trash_chutes"
            placeholder="Мусоропроводы, всего, м"
            required
            value={formDataPublic.trash_chutes || ''}
            onChange={handleInputChange}
          />
        </div>
      </div>
    </div>
  );
};
